/**
 * Product Grid V2 Breaker Slider
 * Web component for the breaker carousel in product grid v2
 */

import { Swiper } from "swiper";
import { Pagination, Autoplay } from "swiper/modules";
import type { SwiperOptions } from "swiper/types";

export default class ProductGridV2BreakerSlider extends HTMLElement {
  private swiper: Swiper | null = null;

  constructor() {
    super();
  }

  connectedCallback(): void {
    this.initSwiper();
  }

  disconnectedCallback(): void {
    this.destroySwiper();
  }

  private initSwiper(): void {
    const pagination = this.querySelector<HTMLElement>(".swiper-pagination");

    const swiperOptions: SwiperOptions = {
      modules: [Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      speed: 500,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
    };

    // Add pagination if element exists
    if (pagination) {
      swiperOptions.pagination = {
        el: pagination,
        clickable: true,
      };
    }

    this.swiper = new Swiper(this, swiperOptions);
  }

  private destroySwiper(): void {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  // Method to pause autoplay
  public pauseAutoplay(): void {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.stop();
    }
  }

  // Method to resume autoplay
  public resumeAutoplay(): void {
    if (this.swiper && this.swiper.autoplay) {
      this.swiper.autoplay.start();
    }
  }

  // Method to go to specific slide
  public goToSlide(index: number): void {
    if (this.swiper) {
      this.swiper.slideTo(index);
    }
  }
}
